import { useEffect } from 'react';
import { useRouter } from 'next/router';

const BeBookingForm: React.FC = (): JSX.Element => {
  const { locale, pathname } = useRouter();

  /* eslint-disable */
  const bookingForm = (w: Window) => {
    // @ts-ignore
    !function(e,n){
      // @ts-ignore
      var t="bookingengine",o="integration",i=e[t]=e[t]||{},a=i[o]=i[o]||{},r="__cq",c="__loader",d="getElementsByTagName";
      // @ts-ignore
      if(n=n||[],a[r]=a[r]?a[r].concat(n):n,!a[c]){a[c]=!0;var l=e.document,g=l[d]("head")[0]||l[d]("body")[0];
        // @ts-ignore
        !function n(i){if(0!==i.length){var a=l.createElement("script");a.type="text/javascript",a.async=!0,a.src="https://"+i[0]+"/integration/loader.js",
          // @ts-ignore
          a.onerror=a.onload=function(n,i){return function(){e[t]&&e[t][o]&&e[t][o].loaded||(g.removeChild(n),i())}}(a,(function(){n(i.slice(1,i.length))})),g.appendChild(a)}}(
          ["al-ibe.hopenapi.com", "ibe.hopenapi.com", "ibe.behopenapi.com"])}
    }(w, [
      ["setContext", "BE-INT-hotelrozafablu-al_2025-06-17", locale],
      ["embed", "booking-form", {
        container: "be-booking-form"
      }]
    ]);
  };
  /* eslint-enable */

  useEffect(() => {
    if (typeof window !== 'undefined') {
      bookingForm(window);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname, locale]);

  return <div id="be-booking-form" />;
};

export default BeBookingForm;
